/**
 * 菜单路由
 */

import User from '../component/console/user/UserIndex'; //用户管理
import Role from '../component/console/role/RoleIndex'; //角色管理
import Org from '../component/console/org/OrgIndex'; //组织管理
import Menu from '../component/console/menu/MenuIndex'; //菜单管理
import Dict from '../component/console/dict/DictIndex'; //数据字典
import SysParam from '../component/console/sysParam/SysParamIndex'; //系统参数
import OperationLog from '../component/console/log/OperationLog'; //操作日志
import LoginLog from '../component/console/log/LoginLog'; //登录日志
import Feedback from '../component/console/feedback/FeedbackIndex'; //意见反馈
import SysCarousel from '../component/console/carousel/CarouselIndex'; //轮播信息管理
import Notice from '../component/console/notice/NoticeIndex'; //公告信息管理
import Document from '../component/console/document/DocumentIndex'; //文档信息维护
import wechatMenu from '../component/console/menu/WechatMenuIndex';      //微信菜单编辑
import wechatUser from '../component/console/notice/WechatUserIndex';      //微信服务号消息测试
import WechatMsgTemplate from '../component/console/wxMsgTemplate/WechatMsgTemplateIndex';      //微信服务号消息模板管理

//车服业务-前台业务
import Application from '../component/trade/transfer/ApplicationIndex'; //申请交易票
import TaxIndex from '../component/trade/transfer/TaxIndex'; //税收缴款书打印功能
import TradeTicket from '../component/trade/transfer/TradeTicketIndex'; //交易票信息
import TradeStatistics from '../component/trade/statistics/StatisticsDayIndex'; //交易汇总信息
import ApplicationHistory from '../component/trade/transfer/ApplicationHistoryIndex'; //申请单历史
import ApplicationPrint from '../component/trade/transfer/ApplicationPrintIndex'; //打印申请表
import TransferRanking from '../component/trade/statistics/TransferRankingIndex'; //过户排行
import JFBrandIndex from '../component/trade/transfer/JFBrandIndex';    //建发代理品牌相关信息
import TradeDeduction from '../component/trade/tradeDeduction/TradeDeductionIndex'; //业务部扣款
import TradeAgentSum from '../component/trade/applyAgent/TradeAgentSumIndex'; //业务部扣款
import TradeAgentStatisticsIndex from '../component/trade/applyAgent/TradeAgentStatisticsIndex'; //代办业务汇总
import ApplyAgent from '../component/trade/applyAgent/AgentApplyIndex'; //转移业务
import ExportCheckReport from '../component/mall/exportCheckReport/ExportCheckReportIndex';

//招商管理模块
import clientManage from '../component/market/client/ClientInfoIndex'; //客户管理
import contractManageIndex from '../component/market/contractManage/ContractManageIndex'; //合同管理
import berthManage from '../component/market/berth/BerthManageIndex'; //铺位管理
import berthSituation from '../component/market/berth/BerthSituationIndex'; //铺位情况
import Floor from '../component/market/berth/FloorIndex'; //楼层管理
import marKetRent from '../component/market/rent/MarketRentIndex'; //收费管理
import BuildingStatisticsIndex from '../component/market/berth/BuildingStatisticsIndex'; //出租统计
import rentSumIndex from '../component/market/rent/RentSumIndex'; //收费汇总
import Building from '../component/market/berth/BuildingIndex'; //市场管理
import billInfoIndex from '../component/market/bill/BillInfoIndex'; //账单管理

//财务相关
import accountRecord from '../component/crm/finance/AccountRecordIndex'; //市场财务信息变动明细
import financialAudit from '../component/crm/finance/FinancialAuditIndex'; //财务审核
import payOrderIndex from '../component/crm/payOrder/PayOrderIndex'; //微信支付账单
import BatchVehicleBillAuditIndex from '../component/barrier/batchVehicleBill/BatchVehicleBillAuditIndex'; //批量车账单审核
import PayStatisticsDayIndex from '../component/crm/payOrder/PayStatisticsDayIndex'; //微信支付统计
import BillTax from '../component/crm/finance/TaxBillIndex'; //税票查询

//柏亿
import VehicleSellIndex from '../component/baiyi/vehicleOrder/VehicleSellIndex'; //车辆销售订单
import VehiclePurchaseIndex from '../component/baiyi/vehicleOrder/VehiclePurchaseIndex'; //车辆采购订单
import OutsideVehicleOrderIndex from '../component/baiyi/outsideVehicleOrder/OutsideVehicleOrderIndex'; //柏亿场外合同
//会员管理
import member from '../component/crm/member/MemberIndex'; //会员管理
import tenant from '../component/crm/tenant/TenantIndex'; //租户商业管理
import tenantProperty from '../component/crm/tenant/TenantProperty'; //租户物管管理
import rentAuditIndex from '../component/market/rent/RentAuditIndex'; //财务审核
import anget from '../component/crm/agent/AgentIndex'; //代办管理
import memberParamIndex from '../component/crm/memberParam/MemberParamIndex'; //会员参数
import memberStatisticsIndex from '../component/crm/memberStatistics/MemberStatisticsIndex'; //会员参数
import MallMember from '../component/crm/mall/MallMemberIndex'; //商城会员
import AuctionMember from '../component/crm/auction/AuctionMemberIndex';    //竞价会员管理
import memberBank from '../component/crm/memberBank/MemberBankIndex';

//周报月报管理
import yearBudget from '../component/market/report/YearBudgetIndex'; //年度预算计划
import weekWrite from '../component/market/report/WeekWriteIndex'; //周报填报
import monthWrite from '../component/market/report/MonthWriteIndex'; //月报填报
import marketActivity from '../component/market/report/MarketActivityIndex'; //市场活动
import weekSum from '../component/market/report/WeekSumIndex'; //周报汇总
import monthSum from '../component/market/report/MonthSumIndex'; //月报汇总

//商城维护管理相关
import vehicleRecommend from '../component/mall/vehicleRecommend/VehicleRecommendIndex'; //精选车辆推荐
import vehicleAudit from '../component/mall/vehicleAudit/VehicleAuditIndex'; //上架车辆审核
import VehicleEvaluate from '../component/mall/vehicleEvaluate/VehicleEvaluateIndex'; //客户端爱车评估信息
import MemberValuate from '../component/mall/memberValuate/MemberValuateIndex'; //商户端车辆评估信息
import ValuationAssessor from '../component/mall/memberValuate/ValuationAssessorIndex';     //评估师信息维护
import ConsultationPrice from '../component/mall/consultationPrice/ConsultationPriceIndex'; //用户咨询底价记录
import TradeLog from '../component/mall/tradeLog/TradeLogIndex'; //商户卖车记录
import MemberBrowse from '../component/mall/memberBrowse/MemberBrowseIndex'; //用户浏览记录
import MemberBrowseSum from '../component/mall/memberBrowse/MemberBrowseSum'; //用户浏览汇总
import VehicleBrowse from '../component/mall/vehicleBrowse/VehicleBrowseIndex'; //车辆浏览记录
import VehicleBrowseSum from '../component/mall/vehicleBrowse/VehicleBrowseSum'; //车辆浏览汇总
import VehicleSharing from '../component/mall/vehicleSharing/VehicleSharingIndex'; //车辆分享记录
import Diversion from '../component/mall/diversion/DiversionIndex'; //小程序导流记录
import UserOrigin from '../component/mall/userOrigin/UserOriginIndex'; //小程序引流来源记录信息
import InstallmentApply from '../component/mall/installment/InstallmentApplyIndex'; //申请分期记录
import FastSell from '../component/mall/fastSell/FastSellIndex'; //极速卖车记录
import VehicleAppointment from '../component/mall/vehicleAppointment/VehicleAppointmentIndex'; //预约看车记录
import VehicleFavorite from '../component/mall/vehicleFavorite/VehicleFavoriteIndex'; //车辆分享记录
import CallMember from '../component/mall/callMember/CallMemberIndex'; //车商主页联系车商记录
import FinancialEntrance from '../component/mall/financialEntrance/FinancialEntranceIndex'; //车商主页联系车商记录
import MallStatistic from '../component/mall/mallStatistic/MallStatisticsIndex'; //数据统计（线上）
import MallStocktatistic from '../component/mall/mallStockStatistic/MallStockStatisticIndex';//数据汇总（线下）
import MallStockQuery from '../component/mall/mallStockQuery/MallStockQueryIndex'; //数据分析
import MallStockAnalysis from '../component/mall/mallStockStatistic/mallStockAnalysis'; //在库数据分析
import MemberStatistic from '../component/mall/memberStatistics/MemberStatisticsIndex'; //商户统计
import Maintenance from '../component/mall/maintenance/MaintenanceIndex'; //维保记录
import DocumentGeneration from '../component/mall/documentGeneration/DocumentGenerationIndex'; //文书生成
import SpecialIndex from '../component/mall/special/SpecialIndex';  //专场信息维护
import ProcurementVehicleIndex from '../component/mall/procurement/ProcurementVehicleIndex';  //采购车辆
import vehicleCheck from '../component/mall/vehicleCheck/VehicleCheckIndex'; //查博士检测
import WizhenCheck from '../component/mall/weizhenCheck/WeizhenCheckIndex'; //维真检测
import procurementPermission from '../component/mall/procurementPermission/ProcurementPermissionIndex'


//竞价管理模块
import AuctionSession from '../component/auction/session/AuctionSessionIndex';  //竞价场次信息管理
import AuctionResult from '../component/auction/result/AuctionResultIndex'; //竞拍品竞价结果记录
import auctionAudit from '../component/auction/audit/AuctionAuditIndex';  //车辆审核
import AuctionCarInfo from '../component/auction/carInfo/AuctionCarInfoIndex';  //竞价车辆
import AuctionSummary from '../component/auction/summary/AuctionSummaryIndex'; //竞价汇总
import AuctionArea from '../component/auction/summary/AuctionSummaryArea'; //竞价区域汇总

//流程管理模块
import ChapterApply from '../component/console/chapterApply/ChapterApplyIndex'; //用章申请审核

//道闸相关模块
import BizParkLog from '../component/barrier/BizParkLog'; //商业车辆出入日志
import SocialParkLog from '../component/barrier/SocialParkLog'; //社会车辆出入日志
import VehicleParkInfo from "../component/barrier/VehicleParkInfo"; //车辆停放记录
import VehicleParkWarn from "../component/barrier/VehicleParkWarn"; //车辆停放异常记录
import ParkGate from "../component/barrier/parkgate/ParkGateIndex"; //道闸信息
import FreeRule from "../component/barrier/feerule/FeeRuleIndex" //收费规则
import PlateNoCard from "../component/barrier/plateNoCard/PlateNoCardIndex"; //白名单管理
import PlateNoBlack from "../component/barrier/plateNoCard/PlateNoBlackIndex"; //黑名单管理
import MemberParkNumber from "../component/barrier/memberPark/MemberParkList"; //商户停车数量查询
import CouponList from "../component/barrier/coupon/CouponList"; //优惠券
import StockCheckList from "../component/barrier/stockCheckBill/StockCheckList"; //盘点记录
import BarrierMember from "../component/barrier/plateNoCard/BarrierMemberIndex"; //停车商户管理
import ParkFeeSum from "../component/barrier/sumreport/ParkFeeSum";
import StockVehicles from "../component/barrier/stockCheckVehicle/StockCheckVehicleIndex"; //盘点车辆
import ParkZone from "../component/barrier/parkZone/parkZoneIndex";//停车区域
import BatchVehilce from '../component/barrier/batchVehicle/BatchVehicleIndex'; //批量车
import BatchVehilceProject from '../component/barrier/batchVehicleProject/BatchVehicleProjectIndex'; //批量车公司
import BatchVehilceBill from '../component/barrier/batchVehicleBill/BatchVehicleBillIndex' //批量车账单

//demo
// import dealInfo from '../component/trade/demo/DealInfo'; //交易信息录入
// import dealChart from '../component/trade/demo/DealChart'; //交易汇总
// import chartMap from '../component/trade/demo/chart/ChartMap'; //交易地图
// import fileView from '../component/demo/FileView'; //文件预览功能
// import message from '../component/common/message/MessageIndex' //消息中心
import RoleUser from "../component/console/roleUser/RoleUserIndex";


export default {
    //菜单
    //车服业务
    //前台业务
    TRANSFER: { component: '', icon: 'dollar' },
    APPLICATION: { component: Application, icon: '' }, //申请交易票
    TAX_TICKET: { component: TaxIndex, icon: '' }, //申请税票
    TRADE_TICKET: { component: TradeTicket, icon: '' }, //交易核对
    TRADE_STATISTICS: { component: TradeStatistics, icon: '' }, //交易汇总
    APPLICATION_HISTORY: { component: ApplicationHistory, icon: '' }, //历史数据
    APPLICATION_PRINT: { component: ApplicationPrint, icon: '' }, //申请表打印
    TRANSFER_RANKING: { component: TransferRanking, icon: '' }, //交易排行
    JF_AGENT_BRAND: { component: JFBrandIndex, icon: '' },    //建发代理品牌
    //交易业务
    TRANSFER_APPLY_AGENT: { component: '', icon: 'exception' },
    APPLY_AGENT_ORDER: { component: ApplyAgent, icon: '' }, //转移业务
    TRADE_DEDUCTION: { component: TradeDeduction, icon: '' }, //其他业务
    TRADE_AGENT_SUM: { component: TradeAgentSum, icon: '' }, // 业务明细（代办的订单信息）
    TRADE_AGENT_STATISTICS: {component: TradeAgentStatisticsIndex, icon: ''}, //服务评价
    //竞价业务
    AUCTION_MANAGER: { component: '', icon: 'shopping' },
    AUCTION_SESSION: { component: AuctionSession, icon: '' }, // 场次维护
    AUCTION_AUDIT: { component: auctionAudit, icon: '' },  //车辆审核
    AUCTION_RESULT: { component: AuctionResult, icon: '' }, // 竞价结果
    AUCTION_CAR_INFO: { component: AuctionCarInfo, icon: '' },  //竞价车辆
    AUCTION_SUMMARY: { component: AuctionSummary, icon: '' }, //交易汇总信息
    AUCTION_AREA: { component: AuctionArea, icon: '' }, //区域汇总
    //中准评估
    VEHICLE_MANAGE: { component: '', icon: 'car' },
    PROCUREMENT_VEHICLE: { component: ProcurementVehicleIndex, icon: '' },   //采购车辆管理
    MEMBER_VALUATE_LOG: { component: MemberValuate, icon: '' }, //商户评估申请
    MALL_DOCUMENT_GENERATION: { component: DocumentGeneration, icon: '' },  //评估报告管理
    EXPORT_CHECK_REPORT: { component: ExportCheckReport, icon: '' },  //出口检测报告
    VALUATION_ASSESSOR: { component: ValuationAssessor, icon: '' }, //评估师管理
    CHECK_ORDER:{component: vehicleCheck, icon: ''},//查博士检测
    WZ_CHECK_ORDER:{component: WizhenCheck, icon: ''},//查博士检测
    PROCUREMENT_PERMISSIONS:{component:procurementPermission ,icon:''},//二手车采购员管理

    //商业管理
    //招商汇总
    INVESTMENT_MANAGER: { component: '', icon: 'shop' },
    CLIENT_MANAGE: { component: clientManage, icon: '' }, //意向客户管理
    CONTRACT_MANAGE: { component: contractManageIndex, icon: '' }, //合同管理
    BERTH_MANAGE: { component: berthManage, icon: '' }, //铺位管理
    BERTH_SITUATION: { component: berthSituation, icon: '' }, //铺位情况
    FLOOR: { component: Floor, icon: '' }, //楼层管理
    MARKET_RENT: { component: marKetRent, icon: '' }, //收费管理
    BUILDINGSTATISTICS: { component: BuildingStatisticsIndex, icon: '' }, //出租统计
    MARKET_RENT_SUM: { component: rentSumIndex, icon: '' }, //收费汇总
    BUILDING: { component: Building, icon: '' }, //市场管理
    MARKET_BILL: { component: billInfoIndex, icon: '' }, //账单管理

    //市场管理
    //客户管理
    CUSTOM: { component: '', icon: 'user' }, //客户管理
    MEMBER: { component: member, icon: '' }, //会员管理
    TENANT: { component: tenant, icon: '' }, //租户商业管理
    TENANTPROPERTY: { component: tenantProperty, icon: '' }, //租户物业管理
    AGENT: { component: anget, icon: '' }, //经纪公司
    MEMBER_PARAM: { component: memberParamIndex, icon: '' }, //会员参数
    MEMBER_STATISTICS: { component: memberStatisticsIndex, icon: '' }, //消费汇总
    MALL_MEMBER: { component: MallMember, icon: '' }, //商城会员
    AUCTION_MEMBER: { component: AuctionMember, icon: '' },  //竞价会员
    MEMBER_BANK: { component: memberBank, icon: '' }, //会员账户管理
    //财务信息
    FINANCE: { component: '', icon: 'transaction' }, //财务信息
    ACCOUNT_RECORD: { component: accountRecord, icon: '' }, //收支明细
    MARKET_RENT_AUDIT: { component: rentAuditIndex, icon: '' }, //财务审核（租金）
    BATCH_VEHICLE_BILL_AUDIT:{ component: BatchVehicleBillAuditIndex, icon: '' },
    FINANCIAL_AUDIT: { component: financialAudit, icon: '' }, //收款审核
    PAY_ORDER_MANAGE: { component: payOrderIndex, icon: '' }, //微信支付账单
    PAY_ORDER_STATISTICS: { component: PayStatisticsDayIndex, icon: '' }, //微信支付统计
    TAX_BILL: {component: BillTax, icon: ''},//税票识别
    //周报月报
    REPORT: { component: '', icon: 'schedule' }, //周报月报
    REPORT_YEAR_BUDGET: { component: yearBudget, icon: '' }, //年度计划
    REPORT_WEEK_WRITE: { component: weekWrite, icon: '' }, //周报填报
    REPORT_MONTH_WRITE: { component: monthWrite, icon: '' }, //月报填报
    REPORT_MARKET_ACTIVITY: { component: marketActivity, icon: '' }, //市场活动
    REPORT_WEEK_SUM: { component: weekSum, icon: '' }, //周报汇总
    REPORT_MONTH_SUM: { component: monthSum, icon: '' }, //月报汇总
    //流程审核
    WORKFLOW: { component: '', icon: 'apartment' }, //流程审核
    CHAPTER_APPLY: { component: ChapterApply, icon: '' }, //用章申请
    //道闸管理
    BARRIER_MANAGER: { component: '', icon: 'import' }, //道闸管理系统
    BARRIER_BIZ_PARK_LOG: { component: BizParkLog, icon: '' }, // 商业车出入信息
    BARRIER_SOCIAL_PARK_LOG: { component: SocialParkLog, icon: '' }, //车辆出入信息
    BARRIER_VEHICLE_PARK_INFO: { component: VehicleParkInfo, icon: '' }, //车辆停放记录
    BARRIER_VEHICLE_PARK_WARN: { component: VehicleParkWarn, icon: '' }, //异常出入信息
    BARRIER_PARK_GATE: { component: ParkGate, icon: '' }, //道闸信息
    BARRIER_MEMBER_PARK_NUM: { component: MemberParkNumber, icon: "" },//商户停车统计
    BARRIER_FEERULE:{component:FreeRule,icon:''}, //收费规则
    BARRIER_WHITE_LIST:{component:PlateNoCard,icon:''}, //白名单管理
    BARRIER_BLACK_LIST:{component:PlateNoBlack,icon:''},//黑名单管理
    BARRIER_COUPON_LIST: { component: CouponList, icon: "" },//停车券查询
    BARRIER_PARK_ZONE: { component: ParkZone, icon: "" },//区域管理
    BARRIER_ONLY_MEMBER: { component: BarrierMember, icon: "" }, //白名单门店
    BARRIER_PARK_FEE_SUM: { component: ParkFeeSum, icon: "" }, //停车费统计
    STOCK_VEHICLE_LIST: { component: StockVehicles, icon: "" }, //盘点车辆管理
    STOCK_CHECK_LIST: { component: StockCheckList, icon: "" },//盘点记录查询
    BARRIER_BATCH_VEHICLE: { component: BatchVehilce,icon: "" }, //批量车管理
    BARRIER_BATCH_VEHICLE_PROJECT: { component: BatchVehilceProject,icon: "" }, //批量车公司
    BARRIER_BATCH_VEHICLE_BILL: { component: BatchVehilceBill,icon: "" }, //批量车账单



    //商城管理
    //商城管理
    MALL_MANAGER: { component: '', icon: 'shopping' }, //商城后台管理
    MALL_MEMBER_STATISTIC: { component: MemberStatistic, icon: '' }, //商户统计
    VEHICLE_RECOMMEND: { component: vehicleRecommend, icon: '' }, //车辆推荐管理
    VEHICLE_AUDIT: { component: vehicleAudit, icon: '' }, //车辆上架审核
    MALL_SPECIAL: { component: SpecialIndex, icon: '' },   //专区管理
    //商城记录
    MALL_RECORD: { component: '', icon: 'eye' },
    MALL_STATISTIC: { component: MallStatistic, icon: '' }, //数据统计（线上）
    MALL_STOCK_STATISTIC: { component: MallStocktatistic, icon: '' }, //数据汇总（线下）
    MALL_STOCK_QUERY:{component:MallStockQuery,icon:''}, //数据分析
    MALL_STOCK_ANALYSIS:{component:MallStockAnalysis,icon:''},//在库数据分析
    USER_EVALUATE_LOG: { component: VehicleEvaluate, icon: '' }, //爱车估价记录
    VEHICLE_BROWSE_LOG: { component: VehicleBrowse, icon: '' }, //车辆浏览记录
    VEHICLE_BROWSE_SUM: { component: VehicleBrowseSum, icon: '' }, //车辆浏览汇总
    MEMBER_BROWSE_LOG: { component: MemberBrowse, icon: '' }, //商户浏览记录
    MEMBER_BROWSE_SUM: { component: MemberBrowseSum, icon: '' }, //商户浏览汇总
    INSTALLMENT_LOG: { component: InstallmentApply, icon: '' }, //申请分期记录
    CONSULTATION_PRICE_LOG: { component: ConsultationPrice, icon: '' }, //咨询底价记录
    TRADE_LOG: { component: TradeLog, icon: '' }, //商户卖车记录
    VEHICLE_SHARING_LOG: { component: VehicleSharing, icon: '' }, //车辆分享记录
    FAST_SELL_LOG: { component: FastSell, icon: '' }, //极速卖车记录
    VEHICLE_APPOINTMENT_LOG: { component: VehicleAppointment, icon: '' }, //预约看车记录
    VEHICLE_FAVORITE_LOG: { component: VehicleFavorite, icon: '' }, //车辆收藏记录
    CALL_MEMBER_LOG: { component: CallMember, icon: '' }, //联系商户记录
    FINANCIAL_ENTRANCE_LOG: { component: FinancialEntrance, icon: '' }, //贷你买车记录
    VEHICLE_MAINTENANCE_LOG: { component: Maintenance, icon: '' }, //维保查询记录
    DIVERSION_LOG: { component: Diversion, icon: '' }, //客户导流记录
    USER_ORIGIN_LOG: { component: UserOrigin, icon: '' }, //商城引流记录信息



    //柏亿
    BUY_SELL: {component: '', icon: 'dollar'}, //采销管理
    VEHICLE_PURCHASE_INDEX: {component: VehiclePurchaseIndex, icon: ''}, //采购订单
    VEHICLE_SELL_INDEX: {component: VehicleSellIndex, icon: ''}, //销售订单
    OUTSIDE_ORDER_INDEX: {component: OutsideVehicleOrderIndex, icon: ''}, //场外订单



    //系统维护
    SYS: { component: '', icon: 'setting' }, //系统管理
    SYS_USER: { component: User, icon: '' }, //用户管理
    SYS_ROLE: { component: Role, icon: '' }, //角色管理
    SYS_ROLE_USER: { component: RoleUser,icon: "" }, //角色用户
    WECHAT_USER: { component: wechatUser, icon: '' }, //微信关注者
    SYS_ORG: { component: Org, icon: '' }, //组织机构
    SYS_MENU: { component: Menu, icon: '' }, //菜单管理
    WECHAT_MENU: { component: wechatMenu, icon: '' }, //服务号菜单
    WX_MSG_TEMPLATE: { component: WechatMsgTemplate, icon: '' }, //服务号消息模板
    SYS_DICT: { component: Dict, icon: '' }, //数据字典
    SYS_PARAM: { component: SysParam, icon: '' }, //系统参数
    SYS_LOG: { component: OperationLog, icon: '' }, //操作日志
    SYS_FEEDBACK: { component: Feedback, icon: '' }, //建议反馈
    SYS_LOGIN_LOG: { component: LoginLog, icon: '' }, //登录日志
    SYS_CAROUSEL: { component: SysCarousel, icon: '' }, //首页轮播
    SYS_NOTICE: { component: Notice, icon: '' }, //公告信息
    SYS_DOCUMENT: { component: Document, icon: '' }, //文档信息
}
